
export default function PrivacyPage() {
  return (
    <div className="min-h-screen bg-gray-950 text-white">
      <div className="max-w-4xl mx-auto px-6 py-16 lg:px-8">
        <div className="mb-8">
          <h1 className="text-4xl font-bold text-white mb-4">Privacy Policy</h1>
          <div className="text-gray-400 text-sm space-y-1">
            <p>Effective Date: November 1, 2025</p>
            <p>Last Updated: November 1, 2025</p>
          </div>
        </div>

        <div className="prose prose-invert max-w-none">
          <p className="text-gray-300 mb-6">
            Ugo Frederick is committed to protecting your privacy and safeguarding the personal information you provide to us. This Privacy Policy outlines how we collect, use, and protect your information in compliance with the Personal Information Protection and Electronic Documents Act (PIPEDA) and other applicable privacy laws.
          </p>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-white mb-4">1. Information We Collect</h2>
            <p className="text-gray-300 mb-4">We may collect personal information such as:</p>
            <ul className="list-disc list-inside text-gray-300 space-y-2 ml-4">
              <li>Your name, email address and phone number;</li>
              <li>Details related to your insurance or financial advisory needs;</li>
              <li>Any other information you voluntarily provide through our website forms or communications.</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-white mb-4">2. How We Use Your Information</h2>
            <p className="text-gray-300 mb-4">We use your information to:</p>
            <ul className="list-disc list-inside text-gray-300 space-y-2 ml-4">
              <li>Respond to your inquiries and provide personalized insurance or financial advisory services;</li>
              <li>Communicate with you about our services, quotes, or products;</li>
              <li>Improve our website and customer experience;</li>
              <li>Comply with legal or regulatory obligations.</li>
            </ul>
            <p className="text-gray-300 mt-4 font-medium">
              We will never sell or rent your personal information to third parties.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-white mb-4">3. Consent</h2>
            <p className="text-gray-300">
              By submitting your personal information through our website, you consent to its collection, use, and disclosure as described in this policy. You may withdraw your consent at any time by contacting us (see Section 6).
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-white mb-4">4. Information Security</h2>
            <p className="text-gray-300">
              We implement reasonable administrative, technical, and physical safeguards to protect your personal information against unauthorized access, loss, or misuse.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-white mb-4">5. Third-Party Links and Services</h2>
            <p className="text-gray-300">
              Our website may contain links to third-party sites or tools. We are not responsible for the privacy practices of those third parties. We encourage you to review their privacy policies before providing any personal information.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-white mb-4">6. Access and Contact</h2>
            <p className="text-gray-300 mb-4">
              You have the right to request access to, or correction of, your personal information.
            </p>
            <p className="text-gray-300 mb-4">
              If you have any questions or concerns about our privacy practices, please contact:
            </p>
            <div className="bg-gray-900 p-4 rounded-lg">
              <p className="text-white font-semibold mb-2">Privacy Officer</p>
              <p className="text-gray-300">Ugo Frederick</p>
              <p className="text-gray-300">Email: info@ugofrederick.com</p>
              <p className="text-gray-300">Phone: +1 (437) 661-5884</p>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-white mb-4">7. Policy Updates</h2>
            <p className="text-gray-300">
              We may update this Privacy Policy from time to time. Any changes will be posted on this page with an updated effective date.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
